import React from 'react';
import App from './ui/components/App';

import './styles/scss/index.scss';

const Root = () => <App />;

export default Root;
